import {call, put, takeLatest} from "@redux-saga/core/effects";
import {
  CHANGE_PASSWORD,
  FORGOT_PASSWORD,
  GET_LOGIN,
  LoginBody,
  LOGOUT,
  RECOVER_PASSWORD,
  RecoverPasswordParams
} from "./Types";
import {AuthActions} from './Slice';
import {PayloadAction} from "@reduxjs/toolkit";
import {
  setLoadingIdle,
  setLoadingPending,
  setLoadingRejected,
  setLoadingResolve,
  toast
} from "../../Utils/Utils";
import {sbxSessionService} from "../../Network";
import * as Services from "../../Services";
import {ModalActions} from "../Modal/Slice";
import {FORGOT_PASSWORD_MODAL, RECOVER_PASSWORD_MODAL} from "../Modal/Types";
import {LOADING_AUTH, LOADING_FORGOT_PASSWORD, LOADING_RECOVER_PASSWORD} from "../Loading/Types";
import {CompanyActions} from "../Company/Slice";
import {Role} from "../../Models/Role";

function* getLogin({payload}: PayloadAction<LoginBody>) {
  try {
    yield put (setLoadingPending(LOADING_AUTH));
    const res = yield call(Services.login, payload.login, payload.password);
    if (res?.success) {
      if (res.response.user.role !== Role.CLIENTE) {
        if (res.response.user.role === Role.MENSAJERO) {
          throw Error("Debes loguearte en la app");
        } else {
          throw Error("Debes loguearte en la pagina de admin");
        }
      }
      sbxSessionService.updateUser({
        token: res.response.token,
        user: res.response.user
      });
      yield put(AuthActions.setLogin(res.response));
      yield put (CompanyActions.clearState());
      yield put (CompanyActions.setCompany(res.response));
      yield put(setLoadingResolve(LOADING_AUTH));
    } else {
      throw Error(res.message);
    }
  } catch (e) {
    yield put(AuthActions.setLoginError());
    toast(e.message, "error");
    yield put (setLoadingRejected(LOADING_AUTH, e.message));
  }
}

function logout() {
  sbxSessionService.logout();
}

function* handleForgotPassword({payload} : any) {
  try {

    yield put (setLoadingPending(LOADING_FORGOT_PASSWORD));
    const res = yield call(Services.forgotPassword, payload.email);
    if (res?.success) {
      toast('Correo enviado');
      yield put (setLoadingResolve(LOADING_FORGOT_PASSWORD));
      yield put (setLoadingIdle(LOADING_FORGOT_PASSWORD));
      yield put(ModalActions.closeModal({modal:FORGOT_PASSWORD_MODAL}));
    } else {
      throw Error(res.message);
    }
  } catch (e) {
    console.log(e)
    toast(e.message, "error");
    yield put(setLoadingRejected(LOADING_FORGOT_PASSWORD, e.message));
  }
}


function* recoverPassword( {payload} : PayloadAction<RecoverPasswordParams> ) {
  try {
    console.log(payload);
    payload.code = payload.code.split('#')[0];
    yield put (setLoadingPending(LOADING_RECOVER_PASSWORD));
    const res = yield call(Services.recoverPassword,payload);
    if(res?.success) {
      toast('Contraseña restablecida');
      yield put (setLoadingResolve(LOADING_RECOVER_PASSWORD));
      yield put(ModalActions.closeModal({modal:RECOVER_PASSWORD_MODAL}));
    }else{
      throw Error(res.message);
    }
  } catch (e) {
    console.log(e);
    toast(e.message, "error");
    yield put(setLoadingRejected(LOADING_RECOVER_PASSWORD, e.message));
  }
}

function* changePassword({payload}:PayloadAction<any>) {
  try {
    console.log(payload)
    yield put (setLoadingPending(LOADING_RECOVER_PASSWORD));
    const res = yield call(Services.changePasswordService, payload.password, payload.repeatPassword);

    if(res?.success) {
      toast('Contraseña actualizada');
      yield put (setLoadingResolve(LOADING_RECOVER_PASSWORD));
      yield put(ModalActions.closeModal({modal:RECOVER_PASSWORD_MODAL}));
    }else{
      throw Error(res.message);
    }
  } catch (e) {
    console.log(e);
    toast(e.message, "error");
    yield put(setLoadingRejected(LOADING_RECOVER_PASSWORD, e.message));
  }
}

export function* authSaga() {
  yield takeLatest(GET_LOGIN, getLogin);
  yield takeLatest(LOGOUT, logout);
  yield takeLatest(FORGOT_PASSWORD, handleForgotPassword);
  yield takeLatest(RECOVER_PASSWORD, recoverPassword);
  yield takeLatest(CHANGE_PASSWORD,changePassword);
}
